export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-08-08 at 20.06.20.b5bea645.jpeg";